import type { ArticlePreviewCardProps } from '~/components/atoms/ArticlePreviewCard/ArticlePreviewCard'
import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'

import type { MagazineIndexBannerProps } from '../MagazineIndexBanner/MagazineIndexBanner'

import Articles from './Articles'

import styles from './ArticlesList.module.css'

export interface ArticlesListProps {
  articles: ArticlePreviewCardProps[]
  inListingBanners?: any
  myPortfolioBanner?: any
  testID?: string
  pageNumber: number
  magazineIndexBanner: MagazineIndexBannerProps
  articlesTypeSlug: string | boolean
  searchInsightsEvents?: {
    article: TSearchAnalystEventProps
    articleLarge?: TSearchAnalystEventProps
    filter?: TSearchAnalystEventProps
  }
  grided?: boolean
  idFilterList?: string[]
  useRowView?: boolean
}

export default function ArticlesList({
  articles,
  inListingBanners,
  myPortfolioBanner,
  pageNumber,
  articlesTypeSlug = false,
  magazineIndexBanner,
  searchInsightsEvents,
  grided,
  idFilterList,
  useRowView = false,
}: ArticlesListProps) {
  return (
    <>
      <Container
        gutters={grided ? gutterTypes.always : gutterTypes.never}
        cssClass={!grided && styles.noMw}
      >
        <Articles
          fallbackData={articles}
          inListingBanners={inListingBanners}
          myPortfolioBanner={myPortfolioBanner}
          pageSize={24}
          pagenumber={pageNumber}
          magazineIndexBanner={magazineIndexBanner}
          articlesTypeSlug={articlesTypeSlug}
          searchInsightsEvents={searchInsightsEvents}
          idFilterList={idFilterList}
          useRowView={useRowView}
        />
      </Container>
    </>
  )
}
